import { render, staticRenderFns } from "./PrescricaoCuidadoMinIcon.vue?vue&type=template&id=ced76fa8"
import script from "./PrescricaoCuidadoMinIcon.vue?vue&type=script&lang=js"
export * from "./PrescricaoCuidadoMinIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports